import { UXComponent } from './component.js';
export default class Chatbot extends UXComponent {
    constructor() {
        super({ visible: false });
        this.reduced = false;
    }
    show() {
        super.show();
        this.reduced = false;
    }
    reduce() {
        this.reduced = true;
    }
    hide() {
        super.hide();
        this.reduced = false;
    }
    isReduced() {
        return this.reduced;
    }
}
//# sourceMappingURL=chatbot.js.map